var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15.75V17.1562C11.25 17.6222 10.8722 18 10.4062 18H0.84375C0.377754 18 0 17.6222 0 17.1562V4.21875C0 3.75275 0.377754 3.375 0.84375 3.375H3.375V13.7812C3.375 14.8668 4.25816 15.75 5.34375 15.75H11.25ZM11.25 3.65625V0H5.34375C4.87775 0 4.5 0.377754 4.5 0.84375V13.7812C4.5 14.2472 4.87775 14.625 5.34375 14.625H14.9062C15.3722 14.625 15.75 14.2472 15.75 13.7812V4.5H12.0938C11.6297 4.5 11.25 4.12031 11.25 3.65625ZM15.5029 2.56539L13.1846 0.247113C13.0264 0.0888899 12.8118 1.16999e-06 12.588 0L12.375 0V3.375H15.75V3.16199C15.75 2.93822 15.6611 2.72362 15.5029 2.56539Z",
    fill: "#BEBEBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.916bf440.svg";
export { ForwardRef as ReactComponent };